import { createAction, props } from "@ngrx/store";
import ISkillType from "@skills-app/models/skillType";

const prefix = "[Edit Skill Type]";

export const requestEditSkillType = createAction(
  `${prefix} Request Edit Skill Type`,
  props<{ skillType: ISkillType }>(),
);
